// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".meet-collect {\n  padding: 10px;\n}\n.actionBar {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n.operational {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    gap: 0 10px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
